var React = require('react');

function IcnBlueArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.6983 7.76175L17.3619 0.342389C16.9105 -0.11413 16.1784 -0.11413 15.727 0.342389C15.2757 0.798907 15.2757 1.53934 15.727 1.99586L21.0013 7.33025L1.15626 7.33025C0.517536 7.33025 0 7.85368 0 8.49969C0 9.14569 0.517536 9.66912 1.15626 9.66912L21.0019 9.66912L15.7276 15.0035C15.2763 15.46 15.2763 16.2005 15.7276 16.657C16.179 17.1135 16.9111 17.1135 17.3625 16.657L24.6989 9.237C25.102 8.82988 25.102 8.16887 24.6989 7.76175H24.6983Z","fill":"#00427C"}));
}

IcnBlueArrow.defaultProps = {"width":"26","height":"17","viewBox":"0 0 26 17","fill":"none"};

module.exports = IcnBlueArrow;

IcnBlueArrow.default = IcnBlueArrow;
